import {
  DeliveryLocationType,
  MessageType,
} from '@savgroup-front-common/types';

import messages from './messages/deliveryLocationTypeMessages';

const getDeliveryLocationTypeMessage = (
  deliveryLocation?: DeliveryLocationType,
): MessageType => {
  switch (deliveryLocation) {
    case DeliveryLocationType.STORE:
      return messages.deliveryLocationStore;
    case DeliveryLocationType.CLIENT:
      return messages.deliveryLocationCustomer;
    case DeliveryLocationType.CUSTOM_ADDRESS:
      return messages.deliveryLocationSpecificAddress;
    case DeliveryLocationType.DEPOSIT_STORE:
      return messages.deliveryLocationDepotstore;
    case DeliveryLocationType.WORKSHOP:
      return messages.deliveryLocationWorkshop;
    case DeliveryLocationType.WAREHOUSE:
      return messages.deliveryLocationWarehouse;
    case DeliveryLocationType.BOX:
      return messages.deliveryLocationBox;
    case DeliveryLocationType.HUB:
      return messages.deliveryLocationHub;
    case DeliveryLocationType.VAN:
      return messages.deliveryLocationVan;
    case DeliveryLocationType.ON_PREMISE:
      return messages.deliveryLocationOnPremise;
    default:
      return messages.deliveryLocationNoAddress;
  }
};

export default getDeliveryLocationTypeMessage;
